module.exports = __webpack_public_path__ + "static/media/dadosPessoais.0bcb7097.svg";